<template>
  <div class="crm-management-dashboard">
    <h1>CRM Management Dashboard</h1>
    <!-- Global filters will go here -->
    <b-row class="row-spacing">
      <b-col cols="12" class="portlet-wrapper">
        <b-card no-body class="portlet">
          <div class="portlet-header">
            <h3 class="text-white">Global Filters</h3>
            <div class="portlet-actions">
              <button>⋮</button>
            </div>
          </div>
          <b-card-body class="portlet-body">
            <GlobalFilterBar
              :base-api="baseApi"
              :access-token="accessToken"
              @filters-changed="handleFiltersChanged"
            />
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!-- Dashboard sections: single API load; use-aggregate stops each child from calling API -->
     <b-row class="row-spacing">
      <b-col cols="12" lg="6" class="portlet-wrapper" v-if="dashboardData && dashboardData.realtime_kpi">
        
        <b-card no-body class="portlet">
          <div class="portlet-header">
            <h3 class="text-white"> Realtime KPIs</h3>
            <div class="portlet-actions">
              <button>⋮</button>
            </div>
          </div>
          <b-card-body class="portlet-body">
        <RealtimeKpiStrip :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" />
        </b-card-body>
        </b-card>
      </b-col>
      <b-col cols="12" lg="6" class="portlet-wrapper" v-if="dashboardData && dashboardData.presales_pipeline">
        <b-card no-body class="portlet">
          <div class="portlet-header">
            <h3 class="text-white"> Presales Pipeline</h3>
            <div class="portlet-actions">
              <button>⋮</button>
            </div>
          </div>
          <b-card-body class="portlet-body">
        <PresalesPipeline :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" @presales-card-click="handlePresalesDrilldown" />
        </b-card-body>
        </b-card>
      </b-col>
      
    </b-row>


    
    <b-row class="row-spacing">
  <b-col cols="12" md="6" lg="6" class="portlet-wrapper" v-if="dashboardData && dashboardData.sales_stage_chart">
    <b-card no-body class="portlet">
      <div class="portlet-header">
        <h3 class="text-white"> Sales by Stage</h3>
        <div class="portlet-actions">
          <button>⋮</button>
        </div>
      </div>
      <b-card-body class="portlet-body">
    <SalesStageChart :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" />
    </b-card-body>
    </b-card>
  </b-col>
  <b-col cols="12" md="6" lg="6" class="portlet-wrapper" v-if="dashboardData && dashboardData.full_funnel_chart">
    <b-card no-body class="portlet">
      <div class="portlet-header">
        <h3 class="text-white"> CRM Funnel Chart</h3>
        <div class="portlet-actions">
          <button>⋮</button>
        </div>
      </div>
      <b-card-body class="portlet-body">
    <FullFunnelChart :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" />
    </b-card-body>
    </b-card>
  </b-col>
  </b-row>
    <b-row v-if="dashboardData" class="row-spacing">
      <b-col cols="12" lg="12" class="portlet-wrapper">
        <b-card no-body class="portlet">
          <div class="portlet-header">
            <h3 class="text-white"> CRM Reports and Summaries</h3>
            <div class="portlet-actions">
    
            </div>
          </div>
          <b-card-body class="portlet-body">
            <b-row class="row-spacing">
              <b-col cols="4" lg="4">
            <TelecallerLeaderboard :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" />
            </b-col>
            <b-col cols="4" lg="4">
            <SmLeaderboard :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" />
            </b-col>
            <b-col cols="4" lg="4">
            <LeadSourceRoi :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" />
            </b-col>
            <b-col cols="4" lg="4">
            <PendingFollowups :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" />
            </b-col>
            <b-col cols="4" lg="4">
            <UpcomingSiteVisits :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" />
            </b-col>
            <b-col cols="4" lg="4">
            <ProjectPerformance :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" />
            </b-col>
            </b-row>
          </b-card-body>
          <div class="portlet-footer">
            <!-- Optional footer content -->
            Updated just now
          </div>
        </b-card>
      </b-col>
      
    </b-row>

    <b-row class="row-spacing">
      <b-col cols="12" lg="12" class="portlet-wrapper" v-if="dashboardData && dashboardData.sales_pipeline">
        <b-card no-body class="portlet">
          <div class="portlet-header">
            <h3 class="text-white"> Sales Pipeline</h3>
            <div class="portlet-actions">
              <button>⋮</button>
            </div>
          </div>
          <b-card-body class="portlet-body">
            <SalesPipeline :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" @sales-card-click="handleSalesDrilldown" />
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-row class="row-spacing">
      <b-col cols="12" md="6">
        <b-row class="row-spacing">
      <b-col cols="12" md="12">
        <b-card no-body class="portlet">
          <div class="portlet-header">
            <h3 class="text-white"> Monthly Lead & Closure Trend</h3>
            <div class="portlet-actions">
    
            </div>
          </div>
          <b-card-body class="portlet-body">
        <MonthlyTrendChart :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" />
        </b-card-body>
        </b-card>
      </b-col>  
      <b-col cols="12" md="12">
        <b-card no-body class="portlet">
          <div class="portlet-header">
            <h3 class="text-white"> Conversion Rate</h3>
            <div class="portlet-actions">
    
            </div>
          </div>
          <b-card-body class="portlet-body">
        <ConversionRateChart :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" />
        </b-card-body>
        </b-card>
      </b-col>
      </b-row>
      </b-col>
      <b-col cols="12" md="6">
        <b-card no-body class="portlet">
          <div class="portlet-header">
            <h3 class="text-white"> Lead Source Pie Chart</h3>
            <div class="portlet-actions">
    
            </div>
          </div>
          <b-card-body class="portlet-body">
        <LeadSourcePieChart :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" />
        </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="row-spacing">
      <b-col cols="12" md="6">
        
        <b-card no-body class="portlet">
          <div class="portlet-header">
            <h3 class="text-white"> Presales Daily Chart</h3>
            <div class="portlet-actions">
    
            </div>
          </div>
          <b-card-body class="portlet-body">
        <PresalesDailyChart :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" />
        </b-card-body>
        </b-card>
      
      </b-col>
      <b-col cols="12" md="6">
        <b-card no-body class="portlet">
          <div class="portlet-header">
            <h3 class="text-white"> Revenue Trend Chart</h3>
            <div class="portlet-actions">
    
            </div>
          </div>
          <b-card-body class="portlet-body">
        <RevenueTrendChart :filters="filters" :user="user" :dashboard-data="dashboardData" :use-aggregate="true" :base-api="baseApi" :access-token="accessToken" />
        </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <!-- Drill-down Modals -->
    <PresalesDrillModal
      :visible.sync="presalesDrillModalVisible"
      :drilldownLevel="currentDrilldownLevel"
      :filters="filters"
      :leadId="currentLeadId"
      :base-api="baseApi"
      :access-token="accessToken"
    />
    <SalesDrillModal
      :visible.sync="salesDrillModalVisible"
      :drilldownLevel="currentDrilldownLevel"
      :filters="filters"
      :saleId="currentSaleId"
      :base-api="baseApi"
      :access-token="accessToken"
    />

  </div>
</template>

<script>
import GlobalFilterBar from '@/components/dashboard/GlobalFilterBar.vue';
import RealtimeKpiStrip from '@/components/dashboard/RealtimeKpiStrip.vue';
import PresalesPipeline from '@/components/dashboard/PresalesPipeline.vue';
import PresalesDailyChart from '@/components/dashboard/PresalesDailyChart.vue';
import SalesPipeline from '@/components/dashboard/SalesPipeline.vue';
import SalesStageChart from '@/components/dashboard/SalesStageChart.vue';
import FullFunnelChart from '@/components/dashboard/FullFunnelChart.vue';
import ConversionRateChart from '@/components/dashboard/ConversionRateChart.vue';
import LeadSourcePieChart from '@/components/dashboard/LeadSourcePieChart.vue';
import MonthlyTrendChart from '@/components/dashboard/MonthlyTrendChart.vue';
import RevenueTrendChart from '@/components/dashboard/RevenueTrendChart.vue';
import TelecallerLeaderboard from '@/components/dashboard/TelecallerLeaderboard.vue';
import SmLeaderboard from '@/components/dashboard/SmLeaderboard.vue';
import LeadSourceRoi from '@/components/dashboard/LeadSourceRoi.vue';
import PendingFollowups from '@/components/dashboard/PendingFollowups.vue';
import UpcomingSiteVisits from '@/components/dashboard/UpcomingSiteVisits.vue';
import ProjectPerformance from '@/components/dashboard/ProjectPerformance.vue';
import PresalesDrillModal from '@/components/dashboard/PresalesDrillModal.vue';
import SalesDrillModal from '@/components/dashboard/SalesDrillModal.vue';
import { BRow, BCol, BCard } from 'bootstrap-vue';
import axios from 'axios';

export default {
  name: 'CrmManagementDashboard',
  components: {
    BRow,
    BCol,
    BCard,
    GlobalFilterBar,
    RealtimeKpiStrip,
    PresalesPipeline,
    PresalesDailyChart,
    SalesPipeline,
    SalesStageChart,
    FullFunnelChart,
    ConversionRateChart,
    LeadSourcePieChart,
    MonthlyTrendChart,
    RevenueTrendChart,
    TelecallerLeaderboard,
    SmLeaderboard,
    LeadSourceRoi,
    PendingFollowups,
    UpcomingSiteVisits,
    ProjectPerformance,
    PresalesDrillModal,
    SalesDrillModal,
  },
  data() {
    return {
      baseApi: process.env.VUE_APP_APIENDPOINT,
      accessToken: localStorage.getItem('accessToken'),
      filters: {}, // Initialize filters
      dashboardData: null, // Single load from /dashboard/crm/all
      presalesDrillModalVisible: false,
      salesDrillModalVisible: false,
      currentDrilldownLevel: '',
      currentLeadId: null,
      currentSaleId: null,
      user: null, // User data for role-based access
      _dashboardFetchTimer: null, // Debounce timer
    };
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.debouncedFetchDashboard();
      },
    },
  },
  methods: {
    handleFiltersChanged(newFilters) {
      this.filters = newFilters;
    },
    debouncedFetchDashboard() {
      if (this._dashboardFetchTimer) clearTimeout(this._dashboardFetchTimer);
      this._dashboardFetchTimer = setTimeout(() => {
        this._dashboardFetchTimer = null;
        this.fetchDashboardData();
      }, 100);
    },
    async fetchDashboardData() {
      if (!this.baseApi || !this.accessToken) return;
      try {
        const response = await axios.get(`${this.baseApi}/dashboard/crm/all`, {
          params: this.filters,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.accessToken}`,
          },
        });
        if (response.data && response.data.data) {
          this.dashboardData = response.data.data;
        }
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
        // Keep previous dashboardData so charts/tables don't flash blank
        if (!this.dashboardData) this.dashboardData = {};
      }
    },
    openPresalesDrillModal(level, leadId = null) {
      this.currentDrilldownLevel = level;
      this.currentLeadId = leadId;
      this.presalesDrillModalVisible = true;
    },
    openSalesDrillModal(level, saleId = null) {
      this.currentDrilldownLevel = level;
      this.currentSaleId = saleId;
      this.salesDrillModalVisible = true;
    },
    handlePresalesDrilldown(cardKey) {
      let level = '';
      switch (cardKey) {
        case 'total_leads':
        case 'qualified_interested_leads':
        case 'site_visit_interested':
          level = 'L1'; // Lead-wise details
          break;
        case 'total_calls_done':
        case 'connected_calls':
          level = 'L2'; // Telecaller-wise + Day-wise (followups)
          break;
        default:
          console.warn('Unknown presales card key for drilldown:', cardKey);
          return;
      }
      this.openPresalesDrillModal(level);
    },
    handleSalesDrilldown(cardKey) {
      let level = '';
      switch (cardKey) {
        case 'prospects_received':
        case 'closure_meeting':
        case 'negotiation':
        case 'final_closure_retail':
        case 'final_closure_bulk':
        case 'total_closures':
        case 'closure_value':
        case 'total_bookings_done':
        case 'booking_value':
          level = 'L1'; // Deal-wise details
          break;
        case 'site_visit_done':
          level = 'SITE_VISIT'; // Custom level for site visits
          break;
        // For SM-wise, a dedicated level like 'SM' would be needed once backend is ready
        default:
          console.warn('Unknown sales card key for drilldown:', cardKey);
          return;
      }
      this.openSalesDrillModal(level);
    },
    async fetchUserData() {
      try {
        const response = await axios.get(`${this.baseApi}/user/profile`, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.accessToken}`,
          },
        });
        this.user = response.data.user;
      } catch (error) {
        console.error('Error fetching user data:', error);
        // Fallback: use userData from localStorage if available
        try {
          const userData = JSON.parse(localStorage.getItem('userData') || '{}');
          this.user = userData && Object.keys(userData).length ? userData : { role: 'admin', userrights: [{ module: 'dashboard', all_data: 1 }] };
        } catch (e) {
          this.user = { role: 'admin', userrights: [{ module: 'dashboard', all_data: 1 }] };
        }
      }
    },
  },
  mounted() {
    this.fetchUserData();
    // Single dashboard fetch: after nextTick GlobalFilterBar will have emitted initial filters, then one fetch runs
    this.$nextTick(() => {
      this.debouncedFetchDashboard();
    });
  },
  beforeDestroy() {
    if (this._dashboardFetchTimer) clearTimeout(this._dashboardFetchTimer);
  },
};
</script>

<style scoped>
.crm-management-dashboard {
  /* Basic styling for the dashboard container */
  padding: 20px;
}

/* Modern Portlet Styles */
.portlet-wrapper {
  /* Removed margin-top and margin-bottom from here, handled by .row-spacing on b-row */
}

.row-spacing {
  margin-top: 20px;
  margin-bottom: 20px;
}

.portlet {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(0,0,0,0.08);
  overflow: hidden;
  transition: 0.3s ease;
  height: 100%; /* Ensure portlet takes full height of its column */
  display: flex;
  flex-direction: column;
}

.portlet:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 24px rgba(0,0,0,0.12);
}

.portlet-header {
  padding: 6px;
  background: linear-gradient(135deg, #4e73df, #224abe);
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.portlet-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.portlet-actions button {
  background: rgba(255,255,255,0.2);
  border: none;
  color: #fff;
  padding: 6px 10px;
  border-radius: 6px;
  cursor: pointer;
}

.portlet-body {
  padding: 20px;
  color: #555;
  font-size: 14px;
  flex-grow: 1; /* Allow body to take available space */
  overflow-y: auto; /* Enable scrolling if content overflows */
}

/* Specific adjustments for embedded components inside the portlet body */
.portlet-body > div { /* Target direct children div (e.g. wrapper of component) */
  margin-bottom: 15px; /* Add some space between embedded components */
  border-bottom: 1px solid #eee; /* Optional: Separator line */
  padding-bottom: 15px;
}

.portlet-body > div:last-child {
  margin-bottom: 0;
  border-bottom: none;
  padding-bottom: 0;
}

.portlet-footer {
  padding: 12px 20px;
  background: #f8f9fc;
  font-size: 13px;
  color: #777;
  border-top: 1px solid #eee;
}
</style>